var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.07 0h1.86v6.042h-1.86V0zM33.01 1.892L31.44.894l-3.252 5.113 1.568.998 3.253-5.113zM13.024.896l3.254 5.112-1.569.998-3.253-5.112 1.569-.998zM43.983 35.31V22.1l.018-.02-.018-.015v-.037h-.04l-9.502-8.552H9.56L.059 22.03H.018v.037L0 22.082l.018.02V35.31a2.75 2.75 0 002.747 2.748h38.47a2.75 2.75 0 002.747-2.748zm-29.31-13.281H2.837l7.437-6.693h23.452l7.437 6.693H29.327v.916a4.126 4.126 0 01-4.121 4.122h-6.412a4.126 4.126 0 01-4.122-4.122v-.916zM1.85 23.86V35.31c0 .505.411.916.916.916h38.47c.505 0 .915-.411.915-.916V23.86H31.09a5.963 5.963 0 01-5.884 5.038h-6.412a5.963 5.963 0 01-5.883-5.037H1.849z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/noData.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };